import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import './button.css'

/**
 * Button
 *
 * variant: default | destructive | outline | secondary | ghost | link
 * size: default | sm | lg | icon
 * asChild: boolean
 */
export function Button({
  variant = 'default',
  size = 'default',
  asChild = false,
  className = '',
  ...props
}) {
  const Comp = asChild ? Slot : 'button'

  return (
    <Comp
      data-slot="button"
      className={`btn btn-${variant} btn-${size} ${className}`}
      {...props}
    />
  )
}
